<template>
    <div id="lang-switcher" class="px-3 py-2">
        <span class="title" @click.prevent="isOpen = !isOpen">
            <img :src="localeImage">
        </span>
        <div class="lang-switcher_items" v-if="isOpen" v-on-click-outside="closeWidget">
            <div class="lang-switcher_item py-1 px-2"
                v-for="(lang_img, lang_alias) in langs"
                :key="lang_alias"
                @click.prevent="selectLanguage(lang_alias)"
            >
                <img :src="lang_img" class="lang-switcher_item-image me-1"> {{ $t('langs.' + lang_alias) }} 
            </div>
        </div>
    </div>
</template>

<script>
import { langs } from '@/lang'
import { vOnClickOutside } from '@vueuse/components'

export default {
    name: 'AppLangSwitcher',
    data() {
        return {
            isOpen: false,
            langs: langs,
            locale: 'en',
            localeImage: null
        }
    },
    directives: {
        onClickOutside: vOnClickOutside
    },
    methods: {
        closeWidget(){
            this.isOpen = false
        },
        selectLanguage(lang_alias){
            this.$root.$i18n.locale = lang_alias
            this.locale = this.$root.$i18n.locale
            this.localeImage = langs[this.locale]
            this.isOpen = !this.isOpen
            localStorage.setItem('sitelocale', this.locale)
            this.$store.commit('setLocale', this.locale)
            this.isOpen = false
        }
    },
    mounted() {
        const defaultLocale = localStorage.getItem('sitelocale') ? localStorage.getItem('sitelocale') : navigator.language.split('-')[0];
        this.selectLanguage(defaultLocale);
    }
}
</script>

<style scoped>
#lang-switcher {
    position: relative;
}
#lang-switcher span.title{
    position: relative;
    cursor: pointer;
}
#lang-switcher span.title{
    position: relative;
    display: block;
    overflow: hidden;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    box-shadow: 0 2px 4px rgba(0,0,0,.2);
}
#lang-switcher span.title img{
    position: absolute;
    top: -5px;
    width: 30px;
    right: -5px;
}
#lang-switcher .lang-switcher_items{
    background: #fff;
    position: absolute;
    right: calc(50% - 130px);
    width: 130px;
    margin-top: 6px;
    transform: translateX(-50%);
    box-shadow: 0 2px 4px rgba(0,0,0,.2);
    border-radius: 6px;
}
#lang-switcher .lang-switcher_item:hover{
    cursor: pointer;
    background-color: hsla(0, .001%, 80%, .333);
}

.lang-switcher_item-image{
    width: 20px;
}
#lang-switcher .lang-switcher_items::after {
    content: '';
    position: absolute;
    top: -4px;
    left: 50%;
    width: 10px;
    height: 10px;
    background-color: #fff;
    transform: translateX(-50%) rotate(45deg);
}
</style>